var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"disable-filtering":"","disable-sort":"","headers":_vm.columns,"items":_vm.rows,"item-class":_vm.itemClass},on:{"click:row":function($event){return _vm.$emit('click:row', $event)}},scopedSlots:_vm._u([_vm._l((_vm.columns),function(ref){
var format = ref.format;
var key = ref.value;
return {key:("item." + key),fn:function(ref){
var isMobile = ref.isMobile;
var item = ref.item;
var header = ref.header;
var value = ref.value;
var index = ref.index;
return [_vm._t(("item." + key),[(format)?[_vm._v(" "+_vm._s(format(value))+" ")]:[_vm._v(" "+_vm._s(value)+" ")]],null,{ format: format, isMobile: isMobile, item: item, header: header, value: value, index: index })]}}})],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }